module.exports = __webpack_public_path__ + "img/politicaNaoImporta.2b63c94f.png";